<template>
  <div class="flex flex-col gap-8">
    <!-- Section Header -->
    <div class="flex items-center gap-8 mobile:flex-col mobile:items-start mobile:gap-2">
      <div class="flex flex-1 items-center gap-2 mobile:flex-col mobile:items-start">
        <h1 class="text-white text-3xl font-bold">Burn Dashboard</h1>
        <span class="bg-white/10 px-2 py-1 rounded text-lg font-medium text-white">
          Auto-Calculated
        </span>
      </div>
      <p class="text-lg font-bold text-white/60">
        * Figures are projections based on accrued revenue and current policies.
      </p>
    </div>

    <!-- Quarterly Burn Status Section -->
    <QuarterlyBurnStatusSection :data="burnOverview" />

    <!-- Middle Section: Circulating Supply Breakdown + Weekly Burn Sources -->
    <section class="grid grid-cols-2 gap-8 laptop:flex laptop:flex-col mobile:flex mobile:flex-col">
      <CirculatingSupplyBreakdownSection :data="supplyBreakdown" />
      <WeeklyBurnSourcesSection
        v-model="selectedPeriod"
        :data="weeklyBurnSources"
      />
    </section>

    <!-- Burn History Section -->
    <BurnHistorySection />
  </div>
</template>

<script setup lang="ts">
import QuarterlyBurnStatusSection from "~/components/@pages/tokenomics/burn-dashboard/QuarterlyBurnStatusSection.vue";
import CirculatingSupplyBreakdownSection from "~/components/@pages/tokenomics/burn-dashboard/CirculatingSupplyBreakdownSection.vue";
import WeeklyBurnSourcesSection from "~/components/@pages/tokenomics/burn-dashboard/WeeklyBurnSourcesSection.vue";
import BurnHistorySection from "~/components/@pages/tokenomics/burn-dashboard/BurnHistorySection.vue";
import { getBurnOverview } from "~/api/service/livewatch/burn-overview.service";
import { getCirculatingSupplyBreakdown } from "~/api/service/livewatch/circulating-supply-breakdown.service";
import {
  getWeeklyBurnSources,
  type WeeklyBurnPeriod,
} from "~/api/service/livewatch/weekly-burn-sources.service";

useSeoMeta({
  title: 'Burn Dashboard',
  description: 'View the NXPC burn status and history on MapleStory Universe Explorer',
  ogDescription: 'View the NXPC burn status and history on MapleStory Universe Explorer',
  twitterDescription: 'View the NXPC burn status and history on MapleStory Universe Explorer',
});

// API 데이터 fetch
const { data: burnOverview } = getBurnOverview();
const { data: supplyBreakdown } = getCirculatingSupplyBreakdown();

const selectedPeriod = ref<WeeklyBurnPeriod>("3M");
const { data: weeklyBurnSources } = getWeeklyBurnSources(selectedPeriod);
</script>
